import ActionsForm from '@/shared/mixins/actionsForm'
export default {
  name: 'Collapsemirrorsales',
  props: ['id', 'title', 'dataParcela', 'dataTable', 'ordem'],
  mixins: [ActionsForm],
  data () {
    return {
      changeAngel: false,
      columns: ['APARTAMENTO', 'ANDAR', 'DORMITÓRIO', 'SOL', 'M²', 'VALOR M²', 'VALOR TOTAL'],
      parcelaReajus: 0

    }
  },
  computed: {
    dataTableCom: function () {
      if (this.dataTable.length === 0) return []
      return this.dataTable.filter((Element) => Element.reEmpreendimentoUnidadePrecoo.nome === this.title)
    },
    getOrdem: function () {
      return this.dataParcela.ordem.toString()
    }
  },
  mounted () {
    this.calCular()
  },
  methods: {
    calCular () {
      if (parseInt(this.title) < 11) {
        this.parcelaReajus = (this.parcela - 6) - parseInt(this.title)
      } else {
        this.parcelaReajus = (this.parcela - 6)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/collapsemirrorsales/collapsemirrorsales.js